import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash as privateIcon } from '@fortawesome/pro-regular-svg-icons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import Commission from './commission';
import DeleteModal from './delete_modal';

import './styles.scss';
import { Button } from 'react-bootstrap-5';

export default function Broker({
  children,
  commission,
  deletable,
  disableCommisionView,
  icon,
  index,
  justify = true,
  transactionSide,
}) {
  const [deleting, setDeleting] = useState();

  // TODO: Consolidate broker/contact styling
  return (
    <div
      className={classNames(
        'broker d-flex flex-row flex-1 align-items-center justify-content-between',
        { justify }
      )}
    >
      <div className="d-flex flex-row align-items-center flex-grow-1 gap-3">
        {icon}
        {children}
      </div>
      <div className="d-flex align-items-center ms-4 gap-2">
        {disableCommisionView ? (
          <span className="text-muted d-flex align-items-center">
            <span className="me-2">Private</span>
            <FontAwesomeIcon icon={privateIcon} />
          </span>
        ) : (
          <>
            <Commission commission={commission} index={index} transactionSide={transactionSide} />
            {deletable &&
              <Button size="icon" variant="ghost" onClick={() => setDeleting(true)}>
                <FontAwesomeIcon
                  icon={faTrash}
                  name="delete-control"
                />
              </Button>
            }
            <DeleteModal
              commission={deleting ? commission : null}
              label="broker"
              onClose={() => setDeleting(false)}
            />
          </>
        )}
      </div>
    </div>
  );
}

Broker.propTypes = {
  children: PropTypes.node,
  commission: PropTypes.object.isRequired,
  deletable: PropTypes.bool,
  disableCommisionView: PropTypes.bool,
  icon: PropTypes.node,
  index: PropTypes.number,
  justify: PropTypes.bool,
  transactionSide: PropTypes.string,
};
